// currentUserStore is dynamically imported to avoid circular dependency
// eslint-disable-next-line @nx/enforce-module-boundaries
import { createIamClient, GetOperation, getSimpleRequestFactory } from '@infuse/api/common';

import { User } from '@infuse/iam/user/type';

const iamClient = createIamClient('/rest/current-user');

export interface CurrentUser {
  permissions: {permissionId: string; subscriptionId: string}[];
  user: User;
}

export const currentUser: GetOperation<CurrentUser> = getSimpleRequestFactory<CurrentUser>(iamClient);
